import { useState } from 'react';

interface UseQueryProps<T, U> {
  queryFn: (...params: T[]) => Promise<U>;
}

interface QueryState<U> {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  data: U | null;
}

export const useQuery = <T, U>({ queryFn }: UseQueryProps<T, U>) => {
  const initialState: QueryState<U> = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: null,
  };

  const [queryState, setQueryState] = useState<QueryState<U>>({ ...initialState });

  return {
    ...queryState,
    reset: () => setQueryState({ ...initialState }),
    queryAsync: async (...params: T[]) => {
      setQueryState({
        isLoading: true,
        isSuccess: false,
        isError: false,
        data: null,
      });

      try {
        const result = await queryFn(...params);
        setQueryState({
          isLoading: false,
          isSuccess: true,
          isError: false,
          data: result,
        });
        return result;
      } catch (err) {
        setQueryState({
          isLoading: false,
          isSuccess: false,
          isError: true,
          data: null,
        });
        // throw err;
      }
    },
  };
};
